import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionCounterService } from '../services/session-counter.service';
import { environment } from '../../environments/environment';

export const refreshSessionClockInterceptor: HttpInterceptorFn = (
  req,
  next,
) => {
  const sessionCounterService = inject(SessionCounterService);
  const excludedUrlFromRefreshSession = ['/logOut'];
  const isExcludedUrl = excludedUrlFromRefreshSession.some((url) =>
    req.url.endsWith(url),
  );
  if (req.url.startsWith(environment.BASE_API) && !isExcludedUrl) {
    sessionCounterService.refreshSessionCounter();
  }

  return next(req);
};
